"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setColumnBarChartUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketHelper_1 = require("../bucketHelper");
var translations_1 = require("../translations");
function setColumnBarChartUiConfig(referencePoint, intl) {
    var _a;
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, uiConfig_1.SUPPORTED_COMPARISON_TYPES], [sdk_ui_1.OverTimeComparisonTypes.SAME_PERIOD_PREVIOUS_YEAR, sdk_ui_1.OverTimeComparisonTypes.PREVIOUS_PERIOD]);
    var buckets = (_a = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.buckets) !== null && _a !== void 0 ? _a : [];
    var measures = bucketHelper_1.getMeasureItems(buckets);
    if (measures.length > 1) {
        var warningMessage = translations_1.getTranslation("dashboard.bucket.measure_stack_by_warning", intl);
        set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.STACK, "canAddItems"], false);
        set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.STACK, "warningMessage"], warningMessage);
    }
    return referencePointConfigured;
}
exports.setColumnBarChartUiConfig = setColumnBarChartUiConfig;
//# sourceMappingURL=columnBarChartUiConfigHelper.js.map